const homepageBody = document.querySelector('.home.section-homepage');

// Only proceed if we're on the homepage
const isHomepage = homepageBody;

if (isHomepage) {
  const homepageNav = document.querySelector('.js-homepage-nav');
  const homepageHero = document.querySelector('.js-homepage-hero');
  const homepageStats = document.querySelector('.js-homepage-stats');

  // For logo color change
  const homepageLogosArray = document.querySelectorAll('.js-homepage-logo');
  // const mobileMenu = document.querySelector('.js-mobileMenu');
  const logoWhite = '/img/logo-white.png';
  const logoDark = '/img/logo.png';

  let homepageHeroHeight = '';
  let homepageStatsHeight = '';
  let homepageNavHeight = '';
  let homepageNavOffset = '';

  // This is purely for changing out the logo when the mobile menu is opened
  // This could be removed if an svg becomes available
  // Might not even be nneded with new design?
  // const observer = new MutationObserver(mutationsList => {
  //   for (const mutation of mutationsList) {
  //     if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
  //       // Check if the class list contains '-opened'
  //       if (mobileMenu.classList.contains('is-active')) {
  //         homepageLogosArray.forEach(logo => (logo.src = logoDark));
  //         console.log('Class applied!');
  //       } else if (
  //         !mobileMenu.classList.contains('is-active') &&
  //         !homepageNav.classList.contains('-secondary')
  //       ) {
  //         // The class has been removed
  //         homepageLogosArray.forEach(logo => (logo.src = logoWhite));
  //       }
  //     }
  //   }
  // });

  const config = { attributes: true, attributeFilter: ['class'] };

  // Start observing the mobileMenu element
  // observer.observe(mobileMenu, config);

  function transitionNav() {
    // If window scroll depth is greater than nav height and less than nav offset, remove initial class
    // place nav just above the viewport
    if (window.scrollY >= homepageHeroHeight / 2 && window.scrollY <= homepageNavOffset) {
      console.log('transitioning nav');
      requestAnimationFrame(() => {
        homepageNav.classList.remove('-initial');
        homepageNav.classList.remove('-secondary');
        homepageNav.style.setProperty(
          '--transitional-top-position',
          `-${homepageNavHeight}px`
        );
      });
    } else if (window.scrollY >= homepageNavOffset) {
      // If window scroll depth is greater than than nav height and greater than nav offset, add secondary class
      // apply secondary styles, scroll nav back into view
      console.log('adding secondary class');
      requestAnimationFrame(() => {
        homepageLogosArray.forEach(logo => (logo.src = logoDark));
        homepageNav.classList.add('-secondary');
        homepageNav.style.setProperty('--transitional-top-position', '0');
      });
    } else if (window.scrollY < homepageHeroHeight / 2) {
      // If window scroll depth is less than nav height, add back initial class
      // apply initial styles, set nav back to initial position
      console.log('adding initial class');
      requestAnimationFrame(() => {
        homepageNav.classList.add('-initial');
        homepageLogosArray.forEach(logo => (logo.src = logoWhite));
        homepageNav.classList.remove('-secondary');
        homepageNav.style.setProperty('--transitional-top-position', '0');
      });
    }
  }

  // Offset is height of hero + stats + nav
  function setHomepageOffset() {
    homepageHeroHeight = homepageHero.offsetHeight;
    homepageStatsHeight = homepageStats.offsetHeight;
    homepageNavHeight = homepageNav.offsetHeight;
    homepageNavOffset = homepageHeroHeight + homepageStatsHeight + homepageNavHeight;
  }

  document.addEventListener('DOMContentLoaded', () => {
    setHomepageOffset();
  });
  document.addEventListener('resize', setHomepageOffset);
  document.addEventListener('scroll', transitionNav);
  window.addEventListener('beforeunload', () => {
    observer.disconnect();
  });
}
